import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const IMAGES = {
  mainBook: "https://cdn.magicpatterns.com/uploads/v1QsaVpyY9GH4JQ5gaVfgx/ChatGPT_Image_27_ago_2026,_17_18_39.webp",
  packCompleto: "https://cdn.magicpatterns.com/uploads/pYiYocj2orM7TxQmykg8r4/ChatGPT_Image_27_ago_2026,_17_16_32.webp",
  bonus1: "https://cdn.magicpatterns.com/uploads/iTZkkpLUE3e6LsQYEsvkdQ/ChatGPT_Image_27_ago_2026,_18_19_26.webp",
  bonus2: "https://cdn.magicpatterns.com/uploads/65MtA98jpsW7xj65LQHk5G/ChatGPT_Image_27_ago_2026,_17_29_24.webp",
  bonus3: "https://cdn.magicpatterns.com/uploads/d3cryZbVaxu2SKdXnovqPQ/ChatGPT_Image_27_ago_2026,_18_21_33.webp",
  sample1: "https://cdn.magicpatterns.com/uploads/1ULH7f1FmH675nFxVrneGL/capture_260827_190244.webp",
  sample2: "https://cdn.magicpatterns.com/uploads/dgmtKHaUo8xWzxK2bTkTL5/capture_260827_190235.webp",
  sample3: "https://cdn.magicpatterns.com/uploads/waAh3auNGD1fAwoapocMQj/capture_260827_190158.webp",
  sample4: "https://cdn.magicpatterns.com/uploads/4FKGaBZFVNJRdVKWwvMjoH/capture_260827_190150.webp",
  sample5: "https://cdn.magicpatterns.com/uploads/tTWrussu1pQDMr7PaKPGj9/capture_260827_190141.webp"
};
const GameDecoration = ({
  type,
  className,
  style
}: {
  type: string;
  className?: string;
  style?: React.CSSProperties;
}) => {
  let svgContent = null;
  switch (type) {
    case 'pickaxe':
      svgContent = <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="crispEdges" className="w-full h-full drop-shadow-[2px_2px_0px_rgba(17,17,17,1)]" data-id="element-0" data-mp="2zlv32jnmchps">
          <path d="M14 2v4h-1V4h-2V3H7V2h7z" fill="#55FFFF" data-id="element-1" data-mp="38m1iwc6shts4" />
          <path d="M13 3v2h-1V4h-1V3h2z" fill="#FFFFFF" data-id="element-2" data-mp="38nup5qdhqbzl" />
          <path d="M14 1h1v6h-1v1h-1v1h-1V8h1V6h1V2h-4v1H8v1H7v1H6V4h1V3h2V2h3V1h2z" fill="#111" data-id="element-3" data-mp="3dl4k1ljnffut" />
          <path d="M11 5h2v2h-2V5zm-2 2h2v2H9V7zM7 9h2v2H7V9zM5 11h2v2H5v-2zM3 13h2v2H3v-2z" fill="#8B6346" data-id="element-4" data-mp="nwc5m3lqig1j" />
          <path d="M10 6h1v1h-1V6zm-2 2h1v1H8V8zm-2 2h1v1H6v-1zm-2 2h1v1H4v-1zm-2 2h1v1H2v-1z" fill="#5C4033" data-id="element-5" data-mp="stkjhrzunxwz" />
          <path d="M12 5h1v2h-1V5zm-2 2h1v2h-1V7zM8 9h1v2H8V9zM6 11h1v2H6v-2zM4 13h1v2H4v-2z" fill="#111" data-id="element-6" data-mp="34x1vh8db93d" />
          <path d="M6 3h1v1H6V3zM12 9h1v1h-1V9z" fill="#111" data-id="element-7" data-mp="3uc9nq9k74apm" />
        </svg>;
      break;
    case 'diamond':
      svgContent = <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="crispEdges" className="w-full h-full drop-shadow-[2px_2px_0px_rgba(17,17,17,1)]" data-id="element-8" data-mp="85l1granwy97">
          <path d="M7 1h2v1h2v1h1v2h1v6h-1v2h-1v1h-2v1H7v-1H5v-1H4v-2H3V5h1V3h1V2h2V1z" fill="#111" data-id="element-9" data-mp="3gja887keygi2" />
          <path d="M7 2h2v1h2v1h1v2h1v5h-1v2h-1v1h-2v1H7v-1H5v-1H4v-2H3V6h1V4h1V3h2V2z" fill="#55FFFF" data-id="element-10" data-mp="3bk736n4foaa3" />
          <path d="M6 3h3v1h1v1h1v2h-1V5H9V4H6V3z" fill="#FFFFFF" data-id="element-11" data-mp="3qd0t72hc08t0" />
          <path d="M11 7v4h-1v2h-2v1H7v-1h2v-1h1V7h1z" fill="#00AAAA" data-id="element-12" data-mp="3liwkadoi9qpa" />
        </svg>;
      break;
    case 'emerald':
      svgContent = <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="crispEdges" className="w-full h-full drop-shadow-[2px_2px_0px_rgba(17,17,17,1)]" data-id="element-13" data-mp="2sw21dl7c6zdx">
          <path d="M6 1h4v2h2v2h1v6h-1v2h-2v2H6v-2H4v-2H3V5h1V3h2V1z" fill="#111" data-id="element-14" data-mp="18byae9zhsj2n" />
          <path d="M6 2h4v2h2v2h1v4h-1v2h-2v2H6v-2H4v-2H3V6h1V4h2V2z" fill="#55FF55" data-id="element-15" data-mp="1d5ssj8zg8pzm" />
          <path d="M6 3h3v1h1v2h-1V4H6V3z" fill="#FFFFFF" data-id="element-16" data-mp="yh6dl8dqi08x" />
          <path d="M10 11v2H6v-1h4v-1z" fill="#00AA00" data-id="element-17" data-mp="13e55dk9xdv3y" />
        </svg>;
      break;
    case 'torch':
      svgContent = <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="crispEdges" className="w-full h-full drop-shadow-[2px_2px_0px_rgba(17,17,17,1)]" data-id="element-18" data-mp="1r5kd5skh14ml">
          <path d="M7 4h2v10H7V4z" fill="#111" data-id="element-19" data-mp="1i4cf9blva5t1" />
          <path d="M7 6h2v8H7V6z" fill="#8B6346" data-id="element-20" data-mp="1i5ni997hn9j3" />
          <path d="M7 4h2v2H7V4z" fill="#FFAA00" data-id="element-21" data-mp="1m4eivqb5x9ay" />
          <path d="M7 3h2v1H7V3z" fill="#FFFF55" data-id="element-22" data-mp="1m792xgq9ks3u" />
          <path d="M7 2h2v1H7V2z" fill="#FFFFFF" data-id="element-23" data-mp="6o5wtptrywld" />
        </svg>;
      break;
    case 'grass-block':
      svgContent = <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="crispEdges" className="w-full h-full drop-shadow-[2px_2px_0px_rgba(17,17,17,1)]" data-id="element-24" data-mp="arkd8hlmlezc">
          <path d="M1 1h14v14H1V1z" fill="#111" data-id="element-25" data-mp="m5dyqdderswh" />
          <path d="M2 5h12v9H2V5z" fill="#8B6346" data-id="element-26" data-mp="m4m16x093l3k" />
          <path d="M2 2h12v3H2V2z" fill="#55A83C" data-id="element-27" data-mp="h8dsa1cnco4u" />
          <path d="M2 2h12v1H2V2z" fill="#75C765" data-id="element-28" data-mp="h4ztf336yx25" />
          <path d="M2 5h1v1h2V5h2v2h2V5h2v1h2V5h1v1h-1v1h-1V6h-2v1H8V6H6v1H4V6H3v1H2V5z" fill="#55A83C" data-id="element-29" data-mp="c9ke06pjct3m" />
        </svg>;
      break;
    case 'chest':
      svgContent = <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="crispEdges" className="w-full h-full drop-shadow-[2px_2px_0px_rgba(17,17,17,1)]" data-id="element-30" data-mp="14wn9sr2tupq6">
          <path d="M1 3h14v10H1V3z" fill="#111" data-id="element-31" data-mp="vwie3e6zxfru" />
          <path d="M2 4h12v8H2V4z" fill="#A67B5B" data-id="element-32" data-mp="vvp484cqqa5h" />
          <path d="M2 4h12v1H2V4zm0 3h12v1H2V7zm0 4h12v1H2v-1zM2 4h1v8H2V4zm11 0h1v8h-1V4z" fill="#3A2418" data-id="element-33" data-mp="3knt1j0d7atox" />
          <path d="M7 6h2v3H7V6z" fill="#111" data-id="element-34" data-mp="3gly1dz70amcq" />
          <path d="M7 6h2v2H7V6z" fill="#CCCCCC" data-id="element-35" data-mp="3gl63uitumejt" />
        </svg>;
      break;
    case 'pig':
      svgContent = <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="crispEdges" className="w-full h-full drop-shadow-[2px_2px_0px_rgba(17,17,17,1)]" data-id="element-36" data-mp="1w2lsqx3r079s">
          <path d="M3 4h10v8H3V4z" fill="#111" data-id="element-37" data-mp="253scrg5lw07s" />
          <path d="M4 5h8v6H4V5z" fill="#FFAAFF" data-id="element-38" data-mp="29wd5sfgou9a9" />
          <path d="M6 8h4v2H6V8z" fill="#FF55FF" data-id="element-39" data-mp="29x4owqt3mejn" />
          <path d="M5 7h1v1H5V7zm4 0h1v1H9V7z" fill="#111" data-id="element-40" data-mp="2evg0p72yez4i" />
          <path d="M4 7h1v1H4V7zm4 0h1v1H8V7z" fill="#FFFFFF" data-id="element-41" data-mp="2ex0swq1sq5z7" />
        </svg>;
      break;
    case 'gold':
      svgContent = <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="crispEdges" className="w-full h-full drop-shadow-[2px_2px_0px_rgba(17,17,17,1)]" data-id="element-42" data-mp="2nv32vv3ic8ym">
          <path d="M5 3h6v2h2v6h-2v2H5v-2H3V5h2V3z" fill="#111" data-id="element-43" data-mp="thlbty3w8tyu" />
          <path d="M5 4h6v2h2v4h-2v2H5v-2H3V6h2V4z" fill="#FFAA00" data-id="element-44" data-mp="tj4v7xkujl4u" />
          <path d="M5 5h4v1h1v2h-1V6H5V5z" fill="#FFFF55" data-id="element-45" data-mp="yfv9qgh068o5" />
          <path d="M9 9v2H5V9h4z" fill="#AA5500" data-id="element-46" data-mp="yihob02b9ofv" />
        </svg>;
      break;
    case 'trophy':
      svgContent = <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="crispEdges" className="w-full h-full drop-shadow-[2px_2px_0px_rgba(17,17,17,1)]" data-id="element-47" data-mp="1wt0sbjeckken">
          <path d="M4 2h8v5H4V2zm-2 2h2v3H2V4zm10 0h2v3h-2V4zm-7 5h2v4H5v-4zm-1 4h6v2H4v-2z" fill="#111" data-id="element-48" data-mp="25t5o0wa6hucz" />
          <path d="M5 3h6v3H5V3zm-2 2h1v1H3V5zm10 0h1v1h-1V5zm-6 4h2v3H7V9zm-2 4h6v1H5v-1z" fill="#FFAA00" data-id="element-49" data-mp="2kq6i36fue1em" />
          <path d="M5 3h2v1H5V3zm-2 2h1v1H3V5z" fill="#FFFF55" data-id="element-50" data-mp="2frljfbg8npsa" />
        </svg>;
      break;
    default:
      return null;
  }
  return <div className={`absolute pointer-events-none z-[1] ${className}`} style={style} data-id="element-51" data-mp="2ti8g6y2fv5lq">
      {svgContent}
    </div>;
};
const CTAButton = ({
  text = "QUIERO ACCEDER AHORA 🎮",
  className = ""
}) => <div className={`flex flex-col items-center w-full ${className}`} data-id="element-52" data-mp="33hfqtdhsgm55">
    <button className="btn-pixel w-full py-4 md:py-5 px-4 text-2xl md:text-3xl flex items-center justify-center text-center leading-tight shadow-[0_6px_0_#111] active:shadow-[0_0px_0_#111] active:translate-y-[6px]" data-id="element-53" data-mp="2yimehoe8n16k">
      {text}
    </button>
    <div className="flex flex-wrap justify-center gap-x-2 gap-y-1 mt-3 text-[12px] font-body font-bold text-[#111]" data-id="element-54" data-mp="3n1y3wtfoavlu">
      <span data-id="element-55" data-mp="387t8yaxlfja8">⚡ Acceso inmediato</span>
      <span data-id="element-56" data-mp="3d3qr8msf2zpn">·</span>
      <span data-id="element-57" data-mp="3d38kuxc1j540">📄 PDF</span>
      <span data-id="element-58" data-mp="3d6mrihrqm0h9">·</span>
      <span data-id="element-59" data-mp="2zd56stnbehpn">🖨️ Imprimible</span>
      <span data-id="element-60" data-mp="2zcvcwuz5fqeo">·</span>
      <span data-id="element-61" data-mp="2zcddjph6ww2j">🔒 Pago seguro</span>
    </div>
  </div>;
const AutoScrollCarousel = () => {
  const scrollRef = React.useRef<HTMLDivElement>(null);
  const [isHovered, setIsHovered] = React.useState(false);
  React.useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    let animationId: number;
    const scroll = () => {
      if (!isHovered) {
        el.scrollLeft += 1;
        if (el.scrollLeft >= el.scrollWidth / 2) {
          el.scrollLeft = 0;
        }
      }
      animationId = requestAnimationFrame(scroll);
    };
    animationId = requestAnimationFrame(scroll);
    return () => cancelAnimationFrame(animationId);
  }, [isHovered]);
  const samples = [IMAGES.sample1, IMAGES.sample2, IMAGES.sample3, IMAGES.sample4, IMAGES.sample5];
  return <div className="w-full relative py-8 overflow-hidden bg-minecraft-landscape bg-cover bg-center border-y-4 border-[#111]" data-id="element-62" data-mp="2qw68nrw9hek4">
      <div className="absolute inset-0 bg-[#1A365D]/85" data-id="element-63" data-mp="2lxuy1ey5700u"></div>
      <motion.h2 initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5
    }} className="font-display text-[26px] md:text-[32px] text-white text-outline text-center mb-8 uppercase relative z-10" data-id="element-64" data-mp="2hwrfulsmgrwg">
        UN VISTAZO POR DENTRO 👀
      </motion.h2>
      <div ref={scrollRef} className="flex gap-6 overflow-x-auto hide-scrollbar px-4 pb-4 snap-x relative z-10" onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} onTouchStart={() => setIsHovered(true)} onTouchEnd={() => setIsHovered(false)} data-id="element-65" data-mp="2396ht6altive">
        {[...samples, ...samples, ...samples].map((src, i) => <div key={i} className="w-[260px] md:w-[320px] flex-shrink-0 bg-white pixel-border hard-shadow p-2 snap-center cursor-grab active:cursor-grabbing hover:-translate-y-2 transition-transform duration-300" data-id="element-66" data-mp="dowsjw1ziht2" data-mpi={i}>
            <img src={src} alt={`Muestra ${i}`} className="w-full h-auto object-cover border-2 border-[#111]" data-id="element-67" data-mp="nnw1zgukqhh4" />
          </div>)}
      </div>
    </div>;
};
const SalesPopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState({
    name: '',
    location: '',
    time: ''
  });
  const names = ['María', 'Laura', 'Florencia', 'Sofía', 'Camila', 'Valeria', 'Romina', 'Luciana', 'Paula', 'Daniela', 'Carolina', 'Mariana', 'Julieta', 'Agustina'];
  const locations = ['Palermo', 'Belgrano', 'Caballito', 'Recoleta', 'Córdoba', 'Rosario', 'Mendoza', 'Mar del Plata', 'La Plata', 'Almagro', 'Vicente López', 'San Isidro', 'Quilmes', 'Neuquén', 'Tucumán'];
  const times = ['hace 2 minutos', 'hace 5 minutos', 'hace 12 minutos', 'hace 1 hora', 'hace 3 minutos', 'hace 8 minutos', 'hace 15 minutos'];
  useEffect(() => {
    // Initial delay before first popup
    const initialTimer = setTimeout(() => {
      showRandomBuyer();
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  const showRandomBuyer = () => {
    const randomName = names[Math.floor(Math.random() * names.length)];
    const randomLocation = locations[Math.floor(Math.random() * locations.length)];
    const randomTime = times[Math.floor(Math.random() * times.length)];
    setCurrentBuyer({
      name: randomName,
      location: randomLocation,
      time: randomTime
    });
    setIsVisible(true);

    // Hide after 5 seconds
    setTimeout(() => {
      setIsVisible(false);

      // Schedule next popup between 10 and 20 seconds later
      const nextDelay = Math.floor(Math.random() * 10000) + 10000;
      setTimeout(showRandomBuyer, nextDelay);
    }, 5000);
  };
  return <AnimatePresence data-id="element-68" data-mp="3rxx9eq68e3iy">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: "spring",
      stiffness: 400,
      damping: 25
    }} className="fixed bottom-4 left-4 z-50 bg-white pixel-border hard-shadow-sm p-3 flex items-center gap-3 max-w-[300px]" data-id="element-69" data-mp="3ryyi4nzrydxi">
          <div className="bg-grass-green w-10 h-10 flex-shrink-0 flex items-center justify-center pixel-border animate-gift-pop" data-id="element-70" data-mp="388v50zmymftx">
            <span className="text-xl" data-id="element-71" data-mp="3468aus2tgitk">🎁</span>
          </div>
          <div className="flex flex-col" data-id="element-72" data-mp="2zaasyhbwn4eo">
            <p className="font-body font-bold text-[13px] text-[#171717] leading-tight" data-id="element-73" data-mp="2z757rd6ecmo8">
              <span className="text-grass-green font-black" data-id="element-74" data-mp="2u9dhenleh8m5">{currentBuyer.name}</span> de {currentBuyer.location} acaba de comprar el pack.
            </p>
            <p className="font-body font-bold text-[11px] text-gray-500 mt-0.5" data-id="element-75" data-mp="2fn6jzz0hs3vl">
              {currentBuyer.time}
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
};
export function App() {
  const faqs = [{
    q: "¿Qué recibo exactamente?",
    a: "Recibís un archivo digital (PDF) con más de 100 actividades de matemáticas, además de los 3 bonos exclusivos detallados en la página."
  }, {
    q: "¿Es un producto físico?",
    a: "No, es un producto 100% digital. Lo recibís en tu correo electrónico listo para descargar e imprimir las veces que quieras."
  }, {
    q: "¿Para qué edades sirve?",
    a: "El material está diseñado para niños que cursan entre 1.º y 5.º grado de primaria (aprox. 6 a 11 años), con niveles de dificultad progresivos."
  }, {
    q: "¿Puedo imprimir las actividades?",
    a: "¡Sí! Está diseñado específicamente para ser impreso. Podés imprimir todo el libro o solo las hojas que necesites en el momento."
  }, {
    q: "¿Puedo utilizarlo más de una vez?",
    a: "Al ser un archivo digital, podés imprimir las actividades todas las veces que necesites para tu hijo o tus alumnos."
  }, {
    q: "¿Sirve para docentes?",
    a: "Absolutamente. Muchos docentes utilizan este material en el aula como una forma divertida de repasar conceptos o como actividades de extensión."
  }, {
    q: "¿Necesito tener Minecraft?",
    a: "No, no es necesario tener el juego ni saber jugarlo. Las actividades usan la estética y temática visual para hacerlas más atractivas, pero se resuelven en papel."
  }, {
    q: "¿Cómo recibo el material?",
    a: "Inmediatamente después de confirmar el pago, recibirás un correo electrónico con los enlaces para descargar todo el material."
  }];
  return <div className="min-h-screen bg-[#111] flex justify-center font-body" data-id="element-76" data-mp="wnqh9oycvbk3">
      <SalesPopup data-id="element-77" data-mp="2d2ibm7f2asw1" />
      {/* Main Container - Narrow centered sales page */}
      <div className="w-full max-w-[800px] bg-sky-blue relative shadow-[0_0_30px_rgba(0,0,0,0.8)] overflow-hidden" data-id="element-78" data-mp="283xcycfgkh9p">
        
        {/* 1. HERO */}
        <section className="w-full bg-minecraft-landscape relative pb-8 overflow-hidden" style={{
        paddingBottom: "0px"
      }} data-id="element-79" data-mp="ho4so6d77sgh">
          {/* Decorative Elements */}
          <GameDecoration type="pickaxe" className="w-[70px] md:w-[90px] -left-[20px] top-[38%] -rotate-[20deg]" data-id="element-80" data-mp="qnrjjy8axfva" />
          <GameDecoration type="diamond" className="w-[40px] md:w-[50px] right-[15px] top-[55%] animate-game-float" data-id="element-81" data-mp="vmuqxpbr7y6f" />
          <GameDecoration type="grass-block" className="w-[40px] md:w-[60px] right-[10%] bottom-[10%]" data-id="element-82" data-mp="10kw8u6xg1rgb" />

          {/* Top Strip */}
          <div className="bg-dark-brown text-white font-body font-bold text-[11px] md:text-sm h-[38px] px-4 flex justify-between items-center border-b-4 border-[#111] relative z-10" data-id="element-83" data-mp="15inz6wifx5ie">
            <span data-id="element-84" data-mp="1ecas8ev9junw">🎮 MATEMÁTICAS EN MODO JUEGO</span>
            <span className="text-[#FFC928]" data-id="element-85" data-mp="1jcp0ny0s16mg">OFERTA ESPECIAL</span>
          </div>

          <div className="px-4 pt-5 pb-2 text-center flex flex-col items-center relative z-10" data-id="element-86" data-mp="1ob0cufejnt7u">
            {/* Small Badge */}
            <motion.div initial={{
            opacity: 0,
            y: -20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5
          }} className="inline-flex items-center justify-center bg-yellow-pixel text-[#111] font-body font-black text-[11px] md:text-sm px-3 h-[32px] pixel-border hard-shadow-sm mb-4 uppercase leading-none" data-id="element-87" data-mp="1yg8btk4fpfl1">
              🎮 +100 ACTIVIDADES · 1.º A 5.º DE PRIMARIA
            </motion.div>
            
            {/* Main Headline */}
            <motion.h1 initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.5,
            delay: 0.1
          }} className="font-display text-[34px] md:text-6xl lg:text-7xl text-white text-outline leading-[1.05] tracking-tight mb-3 uppercase max-w-[95%] animate-mc-breathe" data-id="element-88" data-mp="2c6vchhtr9fjr">
              ¿TU HIJO AMA MINECRAFT<br data-id="element-89" data-mp="2zxqx9uzsnahi" />
              PERO NO LAS <span className="text-[#FFC928]" data-id="element-90" data-mp="2v5hcsuhg72mm">MATEMÁTICAS</span>?
            </motion.h1>
            
            {/* Subheadline */}
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="font-body font-bold text-[#111] text-[16px] leading-[1.3] max-w-[340px] mx-auto mb-4" data-id="element-91" data-mp="t7nnf1vkfwki">
              Convertí la práctica en misiones y desafíos que realmente tenga ganas de completar.
            </motion.p>
            
            {/* Product Image - HUGE */}
            <motion.div initial={{
            opacity: 0,
            y: 40
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.3
          }} className="w-[112%] -ml-[6%] md:w-full md:ml-0 mt-2 mb-6" data-id="element-92" data-mp="afuv79obmfdu">
              <img src={IMAGES.packCompleto} alt="Pack Completo" className="w-full md:w-[95%] mx-auto block drop-shadow-2xl animate-float" data-id="element-93" data-mp="lcpjyzcg9re" />
            </motion.div>
            
            {/* Dark Panel */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.4
          }} className="bg-dark-brown text-white font-body font-black text-[14px] md:text-lg h-[50px] flex items-center justify-center px-3 pixel-border hard-shadow w-full max-w-[95%] mb-5 uppercase tracking-wide" data-id="element-94" data-mp="1uvgd2kek59i5">
              +100 ACTIVIDADES • 5 NIVELES • 3 BONOS GRATIS
            </motion.div>
            
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.5
          }} className="w-full max-w-[95%]" data-id="element-95" data-mp="3pcpud1n6zcsl">
              <CTAButton data-id="element-96" data-mp="2wve5aoc0zxn" />
            </motion.div>
          </div>
        </section>

        {/* Pixel Divider */}
        <div className="w-full flex flex-col relative z-10" data-id="element-97" data-mp="gx648bhtiahr">
          <div className="h-6 bg-grass-green border-y-4 border-[#111]" data-id="element-98" data-mp="by3b9pf43uq5"></div>
          <div className="h-6 bg-medium-brown border-b-4 border-[#111]" data-id="element-99" data-mp="2ip1ceh4v7wv8"></div>
        </div>

        {/* 2. PROBLEMA */}
        <section className="bg-off-white px-4 py-12 relative overflow-hidden" data-id="element-100" data-mp="2dqhle2bezuw0">
          <motion.h2 initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="font-display text-[30px] md:text-[40px] text-[#111] text-center mb-6 uppercase leading-tight relative z-10" data-id="element-101" data-mp="1rwsgq4fqt2fd">
            ¿TU HIJO AMA LOS JUEGOS...<br data-id="element-102" data-mp="26m83l9c5knps" />
            <span className="text-[#E53E3E]" data-id="element-103" data-mp="26kn9fktr36sg">PERO LAS MATEMÁTICAS LE PARECEN ABURRIDAS?</span>
          </motion.h2>
          
          <motion.p initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="font-body font-bold text-lg text-center mb-8 text-[#302A26] relative z-10" data-id="element-104" data-mp="18zra6f6jiu9b">
            Sentarlo a practicar no debería convertirse todos los días en una negociación.
          </motion.p>
          
          <div className="flex flex-col gap-4 mb-10 max-w-[90%] mx-auto relative z-10" data-id="element-105" data-mp="2uard1s6xv6jg">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="bg-white pixel-border hard-shadow p-4 flex items-center gap-4" data-id="element-106" data-mp="2z919050hmb64">
              <span className="text-3xl" data-id="element-107" data-mp="iqa1yg1dar9v">😩</span>
              <p className="font-body font-bold text-[#171717] text-lg" data-id="element-108" data-mp="dw5tfscgeb6o">Se aburre rápidamente</p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.3
          }} className="bg-white pixel-border hard-shadow p-4 flex items-center gap-4" data-id="element-109" data-mp="8xl4ip2njdxj">
              <span className="text-3xl" data-id="element-110" data-mp="3r3ppcrkkx0m0">🧠</span>
              <p className="font-body font-bold text-[#171717] text-lg" data-id="element-111" data-mp="3r4in531k8fs0">Pierde la concentración</p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.4
          }} className="bg-white pixel-border hard-shadow p-4 flex items-center gap-4" data-id="element-112" data-mp="3m6h4ukbykkhl">
              <span className="text-3xl" data-id="element-113" data-mp="2c72qyosezz48">📚</span>
              <p className="font-body font-bold text-[#171717] text-lg" data-id="element-114" data-mp="2c6t254j3vy04">Los ejercicios tradicionales no logran engancharlo</p>
            </motion.div>
          </div>
          
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.5
        }} className="bg-yellow-pixel pixel-border hard-shadow p-6 text-center max-w-[95%] mx-auto relative z-10" data-id="element-115" data-mp="22ghlchebpubt">
            <h3 className="font-body font-black text-xl mb-2 text-[#171717]" data-id="element-116" data-mp="1ogqc0tyr5245">¿Y si en lugar de luchar contra lo que le gusta... lo usamos a nuestro favor?</h3>
            <p className="font-body font-black text-[24px] md:text-[28px] text-[#171717] uppercase mt-4" data-id="element-117" data-mp="1ejln4mdiusjn">
              TRANSFORMÁ LA PRÁCTICA EN UNA MISIÓN.
            </p>
          </motion.div>
        </section>

        {/* Pixel Divider */}
        <div className="w-full flex flex-col relative z-10" data-id="element-118" data-mp="38yo9ib79xuic">
          <div className="h-6 bg-medium-brown border-y-4 border-[#111]" data-id="element-119" data-mp="3helxailunvdj"></div>
          <div className="h-6 bg-grass-green border-b-4 border-[#111]" data-id="element-120" data-mp="3hcj2zmdnzg30"></div>
        </div>

        {/* 3. PRESENTACIÓN DEL PRODUCTO */}
        <section className="bg-sky-blue px-4 py-12 text-center relative overflow-hidden" data-id="element-121" data-mp="3q6ffsakxvg5r">
          <motion.h2 initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="font-body font-black text-[28px] md:text-[34px] text-[#171717] uppercase mb-4 leading-tight relative z-10" data-id="element-122" data-mp="3v5qxpmx1krox">
            CONOCÉ +100 ACTIVIDADES DE MATEMÁTICAS
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="font-body font-bold text-[#171717] text-lg bg-white/80 px-4 py-2 pixel-border inline-block mb-10 max-w-[95%] relative z-10" data-id="element-123" data-mp="37iit777ftmny">
            Una forma diferente de practicar matemática aprovechando un universo que los chicos ya conocen y disfrutan.
          </motion.p>
          
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="w-[85%] max-w-[400px] mx-auto mb-10 relative z-10" data-id="element-124" data-mp="3t6nxhqm2es2h">
            <img src={IMAGES.mainBook} alt="Libro Principal" className="w-full block drop-shadow-2xl animate-float" data-id="element-125" data-mp="3ffsu2tuc536a" />
          </motion.div>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10 text-left max-w-[95%] mx-auto relative z-10" data-id="element-126" data-mp="3aisqqqoveeiv">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.3
          }} className="bg-off-white pixel-border hard-shadow p-4" data-id="element-127" data-mp="3p7ykhz4xvcjd">
              <h4 className="font-body font-black text-[19px] tracking-tight text-[#171717] mb-1 uppercase" data-id="element-128" data-mp="2rqhqz5piiwoz">🎮 APRENDER JUGANDO</h4>
              <p className="font-body font-medium text-[15px] leading-[1.4] text-[#302A26]" data-id="element-129" data-mp="1785yztm4oqyl">Actividades presentadas como desafíos.</p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.4
          }} className="bg-off-white pixel-border hard-shadow p-4" data-id="element-130" data-mp="1c0z3cgdopxa5">
              <h4 className="font-body font-black text-[19px] tracking-tight text-[#171717] mb-1 uppercase" data-id="element-131" data-mp="1pz6u26k4o2cv">🧠 PRACTICAR</h4>
              <p className="font-body font-medium text-[15px] leading-[1.4] text-[#302A26]" data-id="element-132" data-mp="1uwyvpsakr2u9">Conceptos fundamentales de matemática.</p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.5
          }} className="bg-off-white pixel-border hard-shadow p-4" data-id="element-133" data-mp="1h0lgkptijdiy">
              <h4 className="font-body font-black text-[19px] tracking-tight text-[#171717] mb-1 uppercase" data-id="element-134" data-mp="9kfdcqwcgjje">🏆 AVANZAR</h4>
              <p className="font-body font-medium text-[15px] leading-[1.4] text-[#302A26]" data-id="element-135" data-mp="psv92mih2jz1">Cada actividad se convierte en un nuevo logro.</p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.6
          }} className="bg-off-white pixel-border hard-shadow p-4" data-id="element-136" data-mp="g20bilzrzxya">
              <h4 className="font-body font-black text-[19px] tracking-tight text-[#171717] mb-1 uppercase" data-id="element-137" data-mp="18r7hu75h1ru3">🖨️ IMPRIMIR Y USAR</h4>
              <p className="font-body font-medium text-[15px] leading-[1.4] text-[#302A26]" data-id="element-138" data-mp="13sw8dxj39jce">Elegí las actividades que necesites.</p>
            </motion.div>
          </div>
          
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.7
        }} className="max-w-[90%] mx-auto relative z-10" data-id="element-139" data-mp="upv31z21rw9s">
            <CTAButton data-id="element-140" data-mp="3fg2jzpc3gqib" />
          </motion.div>
        </section>

        {/* Pixel Divider */}
        <div className="w-full h-4 bg-[#111] relative z-10" data-id="element-141" data-mp="1v04jyd83fgv9"></div>

        {/* 4. MOSTRAR LAS ACTIVIDADES */}
        <section className="bg-[#1A365D] px-4 py-12 text-center border-b-4 border-[#111] relative overflow-hidden" data-id="element-142" data-mp="1z1hrcrqu3s4a">
          {/* Decorative Elements */}
          <GameDecoration type="pig" className="w-[60px] md:w-[80px] top-[20%] right-[5%] md:right-[15%] rotate-12" data-id="element-143" data-mp="28q7ysj4n88ao" />
          <GameDecoration type="diamond" className="w-[40px] md:w-[50px] bottom-[20%] left-[5%] md:left-[15%] animate-game-float" data-id="element-144" data-mp="2dq472ukdilw1" />

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="font-body font-black text-[22px] md:text-2xl text-yellow-pixel mb-2 uppercase animate-mc-breathe relative z-10" data-id="element-145" data-mp="2in48uta6x2hc">NO ES SOLO UN LIBRO...</motion.h2>
          <motion.h3 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="font-body font-black text-[28px] md:text-[34px] text-white uppercase mb-10 leading-tight relative z-10" data-id="element-146" data-mp="sem6shlktpce">
            SON +100 ACTIVIDADES PARA RESOLVER, PRACTICAR Y SUPERAR
          </motion.h3>
          
          <motion.img initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} src={IMAGES.packCompleto} alt="Hojas de actividades" className="w-[95%] mx-auto block drop-shadow-2xl mb-10 relative z-10" data-id="element-147" data-mp="29kk850fxk0mr" />
          
          <div className="flex flex-wrap justify-center gap-2 max-w-[95%] mx-auto relative z-10" data-id="element-148" data-mp="2sdxvokhbd4sc">
            {['NÚMEROS Y CONTEO', 'SUMAS Y RESTAS', 'MULTIPLICACIONES', 'DIVISIONES', 'TABLAS', 'FRACCIONES', 'GEOMETRÍA', 'MEDIDAS', 'DINERO', 'GRÁFICOS', 'PORCENTAJES', 'PROBLEMAS'].map((tag, i) => <motion.span initial={{
            opacity: 0,
            scale: 0.8
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: 0.3 + i * 0.05
          }} key={i} className="bg-off-white pixel-border hard-shadow px-3 py-1 font-body font-extrabold text-[#171717] text-[14px] md:text-base uppercase" data-id="element-149" data-mp="2xd11i754bf1d" data-mpi={i}>
                {tag}
              </motion.span>)}
          </div>
        </section>

        {/* CAROUSEL DE MUESTRAS */}
        <AutoScrollCarousel data-id="element-150" data-mp="2y79tauvix60i" />

        {/* 5. LOS 5 NIVELES */}
        <section className="bg-off-white px-4 py-12 relative overflow-hidden" data-id="element-151" data-mp="2y5qcn35ygsy7">
          <motion.h2 initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="font-body font-black text-[28px] md:text-[34px] text-[#171717] text-center mb-10 uppercase leading-tight relative z-10" data-id="element-152" data-mp="33030dpegsqfr">
            UN MATERIAL QUE LO ACOMPAÑA DE 1.º A 5.º DE PRIMARIA
          </motion.h2>
          
          <div className="flex flex-col gap-4 max-w-[95%] mx-auto relative z-10" data-id="element-153" data-mp="2ja0u5ezzaxy8">
            {[{
            level: 1,
            grade: "1.º DE PRIMARIA",
            color: "bg-[#55A83C]",
            topics: "Números y conteo • Sumas y restas • Geometría • Medidas • Dinero",
            iconType: "grass-block"
          }, {
            level: 2,
            grade: "2.º DE PRIMARIA",
            color: "bg-[#ED8936]",
            topics: "Valor posicional • Multiplicación • División • Secuencias • Geometría y medidas",
            iconType: "gold"
          }, {
            level: 3,
            grade: "3.º DE PRIMARIA",
            color: "bg-[#4299E1]",
            topics: "Multiplicaciones • Divisiones • Fracciones • Tablas • Perímetro • Problemas",
            iconType: "diamond"
          }, {
            level: 4,
            grade: "4.º DE PRIMARIA",
            color: "bg-[#9F7AEA]",
            topics: "Operaciones • Múltiplos y divisores • Fracciones y decimales • Área • Gráficos",
            iconType: "emerald"
          }, {
            level: 5,
            grade: "5.º DE PRIMARIA",
            color: "bg-[#F56565]",
            topics: "Porcentajes • Proporciones • Volumen • Geometría • Probabilidad",
            iconType: "trophy"
          }].map((lvl, i) => <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: i * 0.15
          }} key={i} className="bg-white pixel-border hard-shadow flex flex-col sm:flex-row relative overflow-hidden z-10" data-id="element-154" data-mp="8jubnpt366kt" data-mpi={i}>
                <div className="absolute -right-4 -bottom-4 opacity-20 drop-shadow-none pointer-events-none w-24 h-24" data-id="element-155" data-mp="mjvakzpsj3xn">
                  <GameDecoration type={lvl.iconType} className="w-full h-full" data-id="element-156" data-mp="3l20k9q98rhg6" />
                </div>
                <div className={`${lvl.color} p-4 border-b-4 sm:border-b-0 sm:border-r-4 border-[#111] flex flex-col justify-center items-center sm:w-1/3 relative z-10`} data-id="element-157" data-mp="3q0u03pc03kji">
                  <span className="font-body font-black text-white text-[20px] uppercase flex items-center gap-2" data-id="element-158" data-mp="3kzj3w5bh3ni">
                    <GameDecoration type={lvl.iconType} className="w-6 h-6 relative" data-id="element-159" data-mp="329g7di9xtmy0" /> NIVEL {lvl.level}
                  </span>
                  <span className="font-body font-bold text-white text-[16px] text-center mt-1 uppercase leading-tight" data-id="element-160" data-mp="377q3bv3hkrko">{lvl.grade}</span>
                </div>
                <div className="p-4 sm:w-2/3 flex items-center" data-id="element-161" data-mp="2lz04155jwpbi">
                  <p className="font-body font-bold text-[#171717] text-[15px] leading-[1.4]" data-id="element-162" data-mp="2lwdwv6mkobtt">{lvl.topics}</p>
                </div>
              </motion.div>)}
          </div>
        </section>

        {/* Pixel Divider */}
        <div className="w-full flex flex-col relative z-10" data-id="element-163" data-mp="1y8w00woganjz">
          <div className="h-6 bg-grass-green border-y-4 border-[#111]" data-id="element-164" data-mp="1y7cht0j8i2fk"></div>
        </div>

        {/* 6. BENEFICIO EMOCIONAL */}
        <section className="bg-sky-blue px-4 py-12 text-center relative overflow-hidden" data-id="element-165" data-mp="1obhuhs42fj6g">
          {/* Decorative Elements */}
          <GameDecoration type="torch" className="w-[30px] md:w-[50px] left-0 top-[40%] animate-torch-flicker" data-id="element-166" data-mp="1taujaiehz0bo" />
          <GameDecoration type="torch" className="w-[30px] md:w-[50px] right-0 top-[40%] animate-torch-flicker" data-id="element-167" data-mp="1fb39ktv0k63h" />

          <div className="bg-off-white pixel-border hard-shadow p-6 md:p-8 max-w-[95%] mx-auto relative z-10" data-id="element-168" data-mp="1kbh4rbbinlk3">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5
          }} className="font-body font-extrabold text-[21px] leading-[1.15] tracking-[-0.3px] text-[#171717] mb-4 uppercase" data-id="element-169" data-mp="10pfl4whs2fet">
              MENOS "NO QUIERO<br data-id="element-170" data-mp="1jmgu0segczo1" />HACER MATEMÁTICA"...
            </motion.h2>
            <motion.h3 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.1
          }} className="font-body font-black text-[27px] leading-[1.05] tracking-[-0.5px] text-[#171717] mb-6 uppercase" data-id="element-171" data-mp="1jkvwctwud0ly">
              Y MÁS...<br data-id="element-172" data-mp="1odyttd4qou7f" />"¿CUÁL ES LA<br data-id="element-173" data-mp="1ofjf0c55z0sm" /><span className="text-[#F6B900]" data-id="element-174" data-mp="1ofjhqjwjtewb">PRÓXIMA MISIÓN?</span>" 🎮
            </motion.h3>
            
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="font-body font-bold text-[#302A26] text-[16px] md:text-[18px] leading-[1.45] mb-8" data-id="element-175" data-mp="1xdvb2tosuqsg">
              No buscamos reemplazar la enseñanza escolar. Buscamos darle una forma diferente de practicar lo que necesita aprender.
            </motion.p>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-left" data-id="element-176" data-mp="18tf20g3g3iun">
              {['Más interés', 'Más práctica', 'Más autonomía', 'Menos resistencia'].map((item, i) => <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: 0.3 + i * 0.1
            }} key={i} className="group flex items-center gap-3 bg-white pixel-border p-3 transition-all duration-200 hover:-translate-y-1 hover:shadow-[4px_4px_0px_0px_#111] cursor-default" data-id="element-177" data-mp="1ioyyb3lx8jjx" data-mpi={i}>
                  <div className="bg-grass-green w-8 h-8 flex items-center justify-center flex-shrink-0 border-2 border-[#111] group-hover:bg-yellow-pixel transition-colors duration-200" data-id="element-178" data-mp="3tj4eimgoesk6">
                    <span className="text-white font-bold text-xl leading-none animate-level-up" style={{
                  animationDelay: `${i * 0.2}s`
                }} data-id="element-179" data-mp="3h7lhjjuj25w0">✓</span>
                  </div>
                  <span className="font-body font-bold text-[16px] text-[#171717] group-hover:text-grass-green transition-colors duration-200" data-id="element-180" data-mp="3875lgvg46116">{item}</span>
                </motion.div>)}
            </div>
          </div>
        </section>

        {/* Pixel Divider */}
        <div className="w-full h-4 bg-[#111] relative z-10" data-id="element-181" data-mp="3quksxyqyag3"></div>

        {/* 7. LOS 3 BONOS */}
        <section className="bg-[#9F7AEA] px-4 py-12 text-center border-b-4 border-[#111] relative overflow-hidden" data-id="element-182" data-mp="3vyugijkbl3lt">
          {/* Decorative Elements */}
          <GameDecoration type="chest" className="w-[60px] md:w-[80px] top-[10%] right-[10%]" data-id="element-183" data-mp="2kima271rp84v" />
          <GameDecoration type="diamond" className="w-[30px] md:w-[40px] top-[30%] left-[5%] animate-game-float" data-id="element-184" data-mp="2fi89tb6er2he" />
          <GameDecoration type="diamond" className="w-[25px] md:w-[35px] bottom-[40%] right-[5%] animate-game-float" style={{
          animationDelay: '1s'
        }} data-id="element-185" data-mp="7908kg5t82po" />
          <GameDecoration type="diamond" className="w-[35px] md:w-[45px] bottom-[10%] left-[10%] animate-game-float" style={{
          animationDelay: '2s'
        }} data-id="element-186" data-mp="3uehsq2vsooxm" />

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="font-body font-black text-[18px] text-yellow-pixel mb-2 uppercase animate-mc-breathe relative z-10" data-id="element-187" data-mp="2bi535akafp2">PERO ESO NO ES TODO...</motion.p>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="font-display text-4xl md:text-5xl text-white text-outline uppercase mb-12 leading-tight animate-mc-breathe relative z-10" data-id="element-188" data-mp="gzbol12rq2cx">
            🎁 TE LLEVÁS 3 BONOS GRATIS
          </motion.h2>
          
          <div className="flex flex-col gap-12 max-w-[90%] mx-auto relative z-10" data-id="element-189" data-mp="2y6bnadcf48xf">
            {/* Bono 1 */}
            <motion.div initial={{
            opacity: 0,
            y: 40
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="bg-white pixel-border hard-shadow p-6 relative" data-id="element-190" data-mp="2u61ktanu40nb">
              <div className="absolute bottom-4 right-4 text-3xl drop-shadow-[2px_2px_0px_rgba(17,17,17,1)] opacity-70" data-id="element-191" data-mp="3356jcgzebtzh">🏆</div>
              <div className="absolute -top-4 -right-2 bg-yellow-pixel text-[#111] font-display text-xl pixel-border px-3 py-1 transform rotate-3 uppercase animate-gift-pop" data-id="element-192" data-mp="2aiu2x2vhgd4h">GRATIS</div>
              <img src={IMAGES.bonus1} alt="Tarjetas de Recompensa" className="w-[80%] max-w-[250px] h-[250px] object-contain mx-auto mb-6 drop-shadow-xl animate-gift-pop" style={{
              animationDelay: '0.5s'
            }} data-id="element-193" data-mp="2kgrrxsl62dy5" />
              <h3 className="font-body font-black text-[18px] text-[#9F7AEA] mb-1 uppercase" data-id="element-194" data-mp="1rsce39dru1oe">BONO #1</h3>
              <h4 className="font-body font-black text-[22px] md:text-[26px] text-[#171717] mb-2 uppercase leading-tight" data-id="element-195" data-mp="3rulpn1gcuc9g">TARJETAS DE RECOMPENSA</h4>
              <p className="font-body font-bold text-[#E53E3E] mb-3 uppercase text-[15px]" data-id="element-196" data-mp="ly52npxut2y">¡DESBLOQUEÁ SUS LOGROS!</p>
              <p className="font-body font-medium text-[#302A26] text-[15px] leading-[1.45] md:text-base" data-id="element-197" data-mp="5gva7jk3kiak">Reconocé cada actividad completada y ayudalo a mantener sus ganas de continuar.</p>
            </motion.div>

            {/* Bono 2 */}
            <motion.div initial={{
            opacity: 0,
            y: 40
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.3
          }} className="bg-white pixel-border hard-shadow p-6 relative" data-id="element-198" data-mp="3dtj2smhjcxxh">
              <div className="absolute bottom-4 right-4 text-3xl drop-shadow-[2px_2px_0px_rgba(17,17,17,1)] opacity-70" data-id="element-199" data-mp="3mvsdbcct0rav">🧭</div>
              <div className="absolute -top-4 -left-2 bg-yellow-pixel text-[#111] font-display text-xl pixel-border px-3 py-1 transform -rotate-3 uppercase animate-gift-pop" style={{
              animationDelay: '0.2s'
            }} data-id="element-200" data-mp="x7rpeqtmqz10">GRATIS</div>
              <img src={IMAGES.bonus2} alt="Mapa de Progreso" className="w-[80%] max-w-[250px] h-[250px] object-contain mx-auto mb-6 drop-shadow-xl animate-gift-pop" style={{
              animationDelay: '0.7s'
            }} data-id="element-201" data-mp="179lxbjgb3ym2" />
              <h3 className="font-body font-black text-[18px] text-[#9F7AEA] mb-1 uppercase" data-id="element-202" data-mp="yhjwhk2bsgb9">BONO #2</h3>
              <h4 className="font-body font-black text-[22px] md:text-[26px] text-[#171717] mb-2 uppercase leading-tight" data-id="element-203" data-mp="thxllh9yzc5m">MAPA DE PROGRESO</h4>
              <p className="font-body font-bold text-[#E53E3E] mb-3 uppercase text-[15px]" data-id="element-204" data-mp="ohj99n1c5g1s">¡QUE VEA TODO LO QUE AVANZÓ!</p>
              <p className="font-body font-medium text-[#302A26] text-[15px] leading-[1.45] md:text-base" data-id="element-205" data-mp="jm3zb66g84an">Convertí cada actividad completada en un paso visible hacia su próxima meta.</p>
            </motion.div>

            {/* Bono 3 */}
            <motion.div initial={{
            opacity: 0,
            y: 40
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.4
          }} className="bg-white pixel-border hard-shadow p-6 relative" data-id="element-206" data-mp="29vxhmh5p2hnl">
              <div className="absolute -top-4 -right-2 bg-yellow-pixel text-[#111] font-display text-xl pixel-border px-3 py-1 transform rotate-3 uppercase animate-gift-pop" style={{
              animationDelay: '0.4s'
            }} data-id="element-207" data-mp="2x5qzz4whzkqa">GRATIS</div>
              <img src={IMAGES.bonus3} alt="Guía para Padres" className="w-[80%] max-w-[250px] h-[250px] object-contain mx-auto mb-6 drop-shadow-xl animate-gift-pop" style={{
              animationDelay: '0.9s'
            }} data-id="element-208" data-mp="2ocxhyzpo278q" />
              <h3 className="font-body font-black text-[18px] text-[#9F7AEA] mb-1 uppercase" data-id="element-209" data-mp="2ehvqvybtyv3i">BONO #3</h3>
              <h4 className="font-body font-black text-[22px] md:text-[26px] text-[#171717] mb-2 uppercase leading-tight" data-id="element-210" data-mp="20idyl8zbszpe">GUÍA PARA PADRES Y DOCENTES</h4>
              <p className="font-body font-medium text-[#302A26] text-[15px] leading-[1.45] md:text-base mt-4" data-id="element-211" data-mp="3uu0znd8t9we8">Ideas prácticas para acompañar, motivar y aprovechar mejor cada actividad, tanto en casa como en el aula.</p>
            </motion.div>
          </div>
          
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.5
        }} className="mt-12 bg-yellow-pixel pixel-border hard-shadow p-4 inline-block max-w-[95%] relative z-10" data-id="element-212" data-mp="dptyu3yzwegt">
            <p className="font-body font-black text-[18px] md:text-[22px] text-[#171717] uppercase leading-tight" data-id="element-213" data-mp="hrylujuxucuh">LOS 3 BONOS ESTÁN INCLUIDOS SIN COSTO EXTRA</p>
          </motion.div>
        </section>

        {/* 8. TODO LO QUE RECIBÍS */}
        <section className="bg-off-white px-4 py-12 relative overflow-hidden" data-id="element-214" data-mp="15jnlyme045lz">
          <motion.h2 initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="font-body font-black text-[28px] md:text-[34px] text-[#171717] text-center mb-10 uppercase leading-tight relative z-10" data-id="element-215" data-mp="11i238kescx3v">
            MIRÁ TODO LO QUE TE LLEVÁS HOY
          </motion.h2>
          
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-white pixel-border hard-shadow p-6 max-w-[95%] mx-auto relative z-10" data-id="element-216" data-mp="1ik158nwaqyy3">
            <img src={IMAGES.packCompleto} alt="Todo lo que recibís" className="w-[95%] mx-auto mb-8 drop-shadow-xl" data-id="element-217" data-mp="1nfq0if1a9tol" />
            
            <ul className="space-y-4 font-body font-bold text-[#171717] text-[16px] md:text-[18px] mb-10" data-id="element-218" data-mp="1whz7iuxcf4x8">
              <li className="flex items-center gap-3" data-id="element-219" data-mp="2b6vlt9pzte6a"><span className="text-2xl" data-id="element-220" data-mp="2b5u3qlak7rf2">📘</span> +100 Actividades de Matemáticas</li>
              <li className="flex items-center gap-3" data-id="element-221" data-mp="267irk3wsl4to"><span className="text-2xl" data-id="element-222" data-mp="268kcr17iv7p4">📚</span> Contenido de 1.º a 5.º de primaria</li>
              <li className="flex items-center gap-3" data-id="element-223" data-mp="2k83dva1x1irx"><span className="text-2xl" data-id="element-224" data-mp="2f8gueivhv6ao">🏆</span> Tarjetas de Recompensa (GRATIS)</li>
              <li className="flex items-center gap-3" data-id="element-225" data-mp="2f6mbtb7p3q9r"><span className="text-2xl" data-id="element-226" data-mp="2ytzawn48rslz">🗺️</span> Mapa de Progreso (GRATIS)</li>
              <li className="flex items-center gap-3" data-id="element-227" data-mp="33t3lni6tdyef"><span className="text-2xl" data-id="element-228" data-mp="33s0povumx5rn">👨‍👩‍👧‍👦</span> Guía para Padres y Docentes (GRATIS)</li>
              <li className="flex items-center gap-3" data-id="element-229" data-mp="2pt145x2f56zp"><span className="text-2xl" data-id="element-230" data-mp="2tv5uomxklni4">📄</span> Material digital</li>
              <li className="flex items-center gap-3" data-id="element-231" data-mp="2ttco17myj3a4"><span className="text-2xl" data-id="element-232" data-mp="2g411o3opjtgr">🖨️</span> Listo para imprimir</li>
              <li className="flex items-center gap-3" data-id="element-233" data-mp="2g1y2ou5kupzw"><span className="text-2xl" data-id="element-234" data-mp="2kur87k8ve2d1">⚡</span> Acceso inmediato</li>
            </ul>
            
            <div className="bg-dark-brown pixel-border p-4 md:p-6 text-center text-white relative mt-6" data-id="element-235" data-mp="266cw0ipkd1jt">
              <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-yellow-pixel text-[#111] font-body font-black text-[12px] md:text-[14px] pixel-border px-3 py-1 uppercase whitespace-nowrap" data-id="element-236" data-mp="2b3wi24si6imb">
                TODO EL MATERIAL + LOS 3 BONOS
              </div>
              
              <div className="flex flex-col md:flex-row items-center justify-center gap-2 md:gap-6 mt-3 mb-4" data-id="element-237" data-mp="7o1bzant042n">
                <div className="flex flex-col items-center" data-id="element-238" data-mp="2w021ve3ypfs">
                  <p className="font-body font-bold text-gray-400 text-[16px] line-through mb-0" data-id="element-239" data-mp="3u3cddtsb88ns">Valor: $35.980</p>
                  <div className="bg-[#E53E3E] text-white font-body font-black px-2 py-0.5 pixel-border text-[14px] uppercase mt-1" data-id="element-240" data-mp="3q2akduozksu9">AHORRÁS 50%</div>
                </div>
                <p className="font-display text-4xl md:text-5xl text-yellow-pixel text-outline-sm uppercase leading-none" data-id="element-241" data-mp="qk9kcnc44v26">
                  <span className="text-[20px] block md:inline md:mr-2 text-white text-outline-none" data-id="element-242" data-mp="hlfsfa9q8suy">HOY</span>
                  $17.990 ARS
                </p>
              </div>
              
              <CTAButton data-id="element-243" data-mp="32bwt46e86y0q" />
            </div>
          </motion.div>
        </section>

        {/* Pixel Divider */}
        <div className="w-full flex flex-col relative z-10" data-id="element-244" data-mp="2xctw998efy3u">
          <div className="h-6 bg-medium-brown border-y-4 border-[#111]" data-id="element-245" data-mp="2xfg1v3bqc3jf"></div>
          <div className="h-6 bg-grass-green border-b-4 border-[#111]" data-id="element-246" data-mp="1cwvtvqgxecdm"></div>
        </div>

        {/* 9. CÓMO FUNCIONA */}
        <section className="bg-sky-blue px-4 py-12 text-center relative overflow-hidden" data-id="element-247" data-mp="1hrrp0zhglfuy">
          <motion.h2 initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="font-body font-black text-[28px] md:text-[34px] text-[#171717] uppercase mb-10 leading-tight relative z-10" data-id="element-248" data-mp="1ltwd7ip51ka7">
            EMPEZAR ES MUY FÁCIL
          </motion.h2>
          
          <div className="flex flex-col gap-6 max-w-[95%] mx-auto relative z-10" data-id="element-249" data-mp="25krompmxpu7r">
            {[{
            step: "1",
            title: "COMPRÁS",
            desc: "Realizás tu compra de forma segura."
          }, {
            step: "2",
            title: "RECIBÍS EL MATERIAL",
            desc: "Accedés al contenido digital al instante."
          }, {
            step: "3",
            title: "IMPRIMÍS Y EMPIEZAN LAS MISIONES",
            desc: "Elegí las actividades y comenzá a utilizarlas."
          }].map((item, i) => <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: i * 0.2
          }} key={i} className="bg-off-white pixel-border hard-shadow p-4 flex items-center gap-4 text-left" data-id="element-250" data-mp="3c16lofg9p2j1" data-mpi={i}>
                <div className="bg-yellow-pixel pixel-border w-14 h-14 flex-shrink-0 flex items-center justify-center font-body font-black text-[24px] text-[#171717]" data-id="element-251" data-mp="2xc0f26f3oa14">
                  {item.step}
                </div>
                <div data-id="element-252" data-mp="3723f2qkn2o8y">
                  <h3 className="font-body font-black text-[18px] md:text-[20px] text-[#171717] uppercase mb-1" data-id="element-253" data-mp="372liq89ms4qw">{item.title}</h3>
                  <p className="font-body font-medium text-[15px] leading-[1.45] text-[#302A26]" data-id="element-254" data-mp="3290kcf44l8r6">{item.desc}</p>
                </div>
              </motion.div>)}
          </div>
        </section>

        {/* Pixel Divider */}
        <div className="w-full flex flex-col relative z-10" data-id="element-255" data-mp="p3vinv5diten">
          <div className="h-6 bg-grass-green border-y-4 border-[#111]" data-id="element-256" data-mp="p2aow7qvvehu"></div>
          <div className="h-6 bg-medium-brown border-b-4 border-[#111]" data-id="element-257" data-mp="twonsk4r83r9"></div>
        </div>

        {/* 10. PARA QUIÉN ES */}
        <section className="bg-medium-brown px-4 py-12 relative overflow-hidden" data-id="element-258" data-mp="g1mc1gd87k6j">
          <motion.h2 initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="font-body font-black text-[28px] md:text-[34px] text-white text-center mb-10 uppercase relative z-10" data-id="element-259" data-mp="k5k9lmmwkmxh">
            IDEAL PARA...
          </motion.h2>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-[95%] mx-auto relative z-10" data-id="element-260" data-mp="13t1gbeokcbkf">
            {[{
            icon: "👦",
            text: "Chicos de 1.º a 5.º de primaria"
          }, {
            icon: "🏠",
            text: "Familias que buscan reforzar matemática en casa"
          }, {
            icon: "👩‍🏫",
            text: "Docentes que buscan actividades diferentes"
          }, {
            icon: "📚",
            text: "Refuerzo escolar"
          }, {
            icon: "☀️",
            text: "Vacaciones"
          }, {
            icon: "🧠",
            text: "Práctica semanal"
          }].map((item, i) => <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: i * 0.1
          }} key={i} className="bg-off-white pixel-border hard-shadow p-4 flex items-center gap-4" data-id="element-261" data-mp="1kbo1i78o1axd" data-mpi={i}>
                <span className="text-3xl" data-id="element-262" data-mp="16cek548q4art">{item.icon}</span>
                <span className="font-body font-bold text-[#171717] text-base" data-id="element-263" data-mp="11duxf1mb2uye">{item.text}</span>
              </motion.div>)}
          </div>
        </section>

        {/* Pixel Divider */}
        <div className="w-full h-4 bg-[#111] relative z-10" data-id="element-264" data-mp="2vsxi8m0etouz"></div>

        {/* 11. FAQ */}
        <section className="bg-off-white px-4 py-12 relative overflow-hidden" data-id="element-265" data-mp="2rqj1q8k7r16v">
          <motion.h2 initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="font-body font-black text-[28px] md:text-[34px] text-[#171717] text-center mb-10 uppercase relative z-10" data-id="element-266" data-mp="djb15xwmoed2">
            PREGUNTAS FRECUENTES
          </motion.h2>
          
          <div className="flex flex-col gap-4 max-w-[95%] mx-auto relative z-10" data-id="element-267" data-mp="ra6ebme5thmg">
            {faqs.map((faq, i) => <motion.details initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: i * 0.1
          }} key={i} className="group bg-white pixel-border hard-shadow" data-id="element-268" data-mp="3qrwav9d5m4dt" data-mpi={i}>
                <summary className="font-body font-black text-[16px] md:text-[18px] p-4 cursor-pointer flex justify-between items-center list-none uppercase text-[#171717]" data-id="element-269" data-mp="8l9mdp68j17e">
                  <span className="pr-4" data-id="element-270" data-mp="1jyu3ht214r5a">{faq.q}</span>
                  <span className="text-2xl group-open:rotate-180 transition-transform" data-id="element-271" data-mp="1k1gbtuwqvaok">▼</span>
                </summary>
                <div className="p-4 pt-0 font-body font-medium text-[15px] leading-[1.45] text-[#302A26] border-t-4 border-[#111]" data-id="element-272" data-mp="qnp0x2i5fsc1">
                  {faq.a}
                </div>
              </motion.details>)}
          </div>
        </section>

        {/* Pixel Divider */}
        <div className="w-full flex flex-col relative z-10" data-id="element-273" data-mp="zmk5ka5joud8">
          <div className="h-6 bg-medium-brown border-y-4 border-[#111]" data-id="element-274" data-mp="1ebzstg5vaho6"></div>
          <div className="h-6 bg-grass-green border-b-4 border-[#111]" data-id="element-275" data-mp="19ezob9oo1mz6"></div>
        </div>

        {/* 12. CTA FINAL */}
        <section className="bg-sky-blue px-4 py-16 text-center relative overflow-hidden" data-id="element-276" data-mp="1ncob4n2an46v">
          {/* Decorative Elements */}
          <GameDecoration type="torch" className="w-[30px] md:w-[50px] left-[5%] top-[30%] animate-torch-flicker" data-id="element-277" data-mp="1ja9p5u3bvobd" />
          <GameDecoration type="torch" className="w-[30px] md:w-[50px] right-[5%] top-[30%] animate-torch-flicker" data-id="element-278" data-mp="3l3qw0vjmwl52" />
          <GameDecoration type="diamond" className="w-[40px] md:w-[60px] right-[20%] bottom-[30%] animate-game-float" data-id="element-279" data-mp="3azagk3a2h61s" />
          <GameDecoration type="grass-block" className="w-[40px] md:w-[50px] left-[10%] bottom-[-10px]" data-id="element-280" data-mp="3f0chqpnjns6e" />
          <GameDecoration type="grass-block" className="w-[30px] md:w-[40px] left-[25%] bottom-[-5px]" data-id="element-281" data-mp="318xvm9ycbav4" />
          <GameDecoration type="grass-block" className="w-[50px] md:w-[60px] right-[15%] bottom-[-15px]" data-id="element-282" data-mp="367sq495o6nv2" />

          <motion.h2 initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="font-body font-black text-[28px] md:text-[34px] text-[#171717] uppercase mb-6 leading-tight relative z-10" data-id="element-283" data-mp="2ra9tylqnx8dl">
            HOY PUEDE SER EL DÍA EN QUE PRACTICAR MATEMÁTICA DEJE DE SER UNA PELEA.
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="font-body font-bold text-[#171717] text-[16px] md:text-[18px] bg-white/80 px-4 py-2 pixel-border inline-block mb-10 max-w-[95%] relative z-10" data-id="element-284" data-mp="gl341hwdrt9o">
            Transformá sus ejercicios en desafíos que realmente tenga ganas de completar.
          </motion.p>
          
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-off-white pixel-border hard-shadow p-6 max-w-[95%] mx-auto relative z-10" data-id="element-285" data-mp="21z5drh8mcgfs">
            <img src={IMAGES.packCompleto} alt="Pack Completo" className="w-[95%] mx-auto mb-8 drop-shadow-xl" data-id="element-286" data-mp="2b1wotfxl1a6w" />
            
            <div className="flex flex-col gap-3 mb-8" data-id="element-287" data-mp="2kxztotjtjmxj">
              <span className="bg-grass-green text-white font-body font-black pixel-border px-4 py-2 text-[18px] uppercase" data-id="element-288" data-mp="2kxhv3q9oowmg">+100 ACTIVIDADES</span>
              <span className="bg-yellow-pixel text-[#111] font-body font-black pixel-border px-4 py-2 text-[18px] uppercase" data-id="element-289" data-mp="qjqgecchzmk5">+ 3 BONOS GRATIS</span>
            </div>
            
            <div className="bg-dark-brown pixel-border p-4 md:p-6 text-center text-white mb-6" data-id="element-290" data-mp="2z3tdfrgtyx5m">
              <div className="flex flex-col md:flex-row items-center justify-center gap-2 md:gap-6 mb-4" data-id="element-291" data-mp="2v27rzhq8dajt">
                <div className="flex flex-col items-center" data-id="element-292" data-mp="2q3daqk7wvu1t">
                  <p className="font-body font-bold text-gray-400 text-[16px] line-through mb-0" data-id="element-293" data-mp="2q4y62c21vh0q">Antes: $35.980</p>
                  <div className="bg-[#E53E3E] text-white font-body font-black px-2 py-0.5 pixel-border text-[14px] uppercase mt-1" data-id="element-294" data-mp="3mr9qxnzfsnci">AHORRÁS 50%</div>
                </div>
                <p className="font-display text-4xl md:text-5xl text-yellow-pixel text-outline-sm uppercase leading-none" data-id="element-295" data-mp="3dr4m9llmo321">
                  <span className="text-[20px] block md:inline md:mr-2 text-white text-outline-none" data-id="element-296" data-mp="38vp9kwzcwd77">HOY</span>
                  $17.990 ARS
                </p>
              </div>
              <CTAButton data-id="element-297" data-mp="1xcuzgvx1amdb" />
            </div>
          </motion.div>
        </section>
        
        {/* Footer */}
        <footer className="bg-[#111] text-gray-400 py-8 px-4 text-center font-body font-bold text-xs border-t-4 border-[#111] relative z-10" data-id="element-298" data-mp="1ytiinfe1g6ol">
          <p className="mb-2" data-id="element-299" data-mp="1pvgc6kbjcltx">© {new Date().getFullYear()} Lectura Mundo Bloques. Todos los derechos reservados.</p>
          <p data-id="element-300" data-mp="1usymof57b941">Este producto no está asociado, afiliado, respaldado, certificado ni patrocinado por Mojang AB o Microsoft. Minecraft es una marca registrada de Mojang Synergies AB.</p>
        </footer>

      </div>
    </div>;
}